import { accessTokenStore, userStore } from 'entities/index';
import { SSOApi } from 'shared/api';
import { ISignInDto } from 'shared/api/sso/interfaces/sso.interfaces';

export const signIn = async (
  typeLogin: string,
  login: string,
  password: string
) => {
  // Проверка: телефон или почта введены в поле логина
  const dto: ISignInDto = {
    password,
    ...(typeLogin === 'phone' ? { phone: login } : { email: login }),
  };
  const accessToken = await SSOApi.signIn(dto);
  accessTokenStore.setToken(accessToken);
  await userStore.init();
  sessionStorage.removeItem('licenseWarningShown');
};
